//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbHeaderBaseSidePanel from '@/elements/header/panels/base-side-panel.vue'
import RbHeaderWishlist from '@/elements/header/wishlist/header-wishlist.vue'
import { mapGetters } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import i18n from '@/scripts/libs/i18n'

export default {
  name: 'rb-header-account-side-panel',
  components: {
    RbHeaderWishlist,
    RbHeaderBaseSidePanel,
  },
  props: {
    isOpen: Boolean,
    zIndex: Number,
    offsets: Object,
    headerIsCollapsed: Boolean,
    wcagHiddenButtonIsFocusable: Boolean,
  },
  computed: {
    ...mapGetters(['userLoggedIn', 'userName', 'menuItems', 'translation']),
    panelTitle() {
      if (this.isUserLoggedIn) {
        return `hi, ${this.userName}`
      }
      return this.$t('my_account.label')
    },
    isUserLoggedIn() {
      return this.userLoggedIn
    },
    headerLoginPageUrl() {
      const headerLoginUrl = wcs.getEndPoint('headerLoginUrl')
      return headerLoginUrl
    },
  },
  created() {
    i18n.loadTranslationsBySection('my-account')
  },
  methods: {
    closePanel() {
      this.$emit('panelClosed')
    },
  },
}
